export default "__VITE_ASSET__DerOgn6z__"